import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import CssClass from "../../../Styles/common.module.css";
import http from "../../../common/http-common";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";

const CancelTicket = (props) => {

    const [cookies] = useCookies([]);
    const [userId] = useState(cookies.USER_ID);

    const [editData, setEditData] = useState([]);
    const [inputError, setInputError] = useState([]);

    useEffect(() => {
      if (props.viewData !== undefined) {
        setEditData({
          TICKET_MST_ID: props.viewData.TICKET_MST_ID,
          TICKET_NUM: props.viewData.TICKET_NUM,
          ORG_ID: props.viewData.ORG_ID,
          SYSTEM_MST_ID: props.viewData.SYSTEM_MST_ID,
          SYSTEM_MST_NAME: props.viewData.SYSTEM_MST_NAME,
          ACKNOWLEDGED_DATETIME: props.viewData.ACKNOWLEDGED_DATETIME,
          TOTAL_COMPLETE_TIME: props.viewData.TOTAL_COMPLETE_TIME,
          RESPONSE_DETAILS: editData.RESPONSE_DETAILS,
          UPDATE_ID: userId,
          UPDATE_DATETIME: props.viewData.UPDATE_DATETIME,
        })
      }
    }, [props.viewData, userId])

    const SendEmail = (_data) => {
      let functionName = SendEmail.name;

      try {
        props.onLoading(true, "Sending email, please wait...");
        const data = {
          TICKET_MST_ID: _data.TICKET_MST_ID,
          TICKET_NUM: _data.TICKET_NUM,
          ORG_ID: _data.ORG_ID,
          SYSTEM_MST_ID: _data.SYSTEM_MST_ID,
          SYSTEM_MST_NAME: _data.SYSTEM_MST_NAME,
          RESPONSE_DETAILS: _data.RESPONSE_DETAILS,
          UPDATE_ID: userId,
        };
        http
          .post("api/ticket/SendCancelEmail", data, {timeout: common.DEFAULT_TIMEOUT})
          .then((response) => {
            props.onLoading(true, "Sending email...");
          })
          .catch((err) => {
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          })
      } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to send email.");
        common.c_LogWebError(props.page, functionName, err);
      }
    };

    const cancelBtnOnClick = () => {

      var flag = true;

      if (editData.RESPONSE_DETAILS === undefined) {
        flag = false;

        setInputError((prevState) => ({
          ...prevState,
          RESPONSE_DETAILS: "Reason could not be empty."
        }))
      }

      if (Object.values(inputError).filter(v => v !== "").length === 0 && flag) {
        CancelTicket(editData);
      }
    }

    function CancelTicket(_data) {
      let functionName = "";

      try {
        functionName = CancelTicket.name

        props.onLoading(true, "Cancelling ticket, please wait...");

        const data = {
          TICKET_MST_ID: _data.TICKET_MST_ID,
          TICKET_NUM: _data.TICKET_NUM,
          TOTAL_COMPLETE_TIME: _data.TOTAL_COMPLETE_TIME === "" ? null : _data.TOTAL_COMPLETE_TIME,
          RESPONSE_DETAILS: "TICKET CANCELLED \n Reason: " + _data.RESPONSE_DETAILS,
          UPDATE_ID: userId,
          UPDATE_DATETIME: _data.UPDATE_DATETIME,
        }

        http
        .put("api/ticket/CancelTicket", data, { timeout:10000 })
        .then((response) => {
          if (response.data.CLOSE_STATUS === true || response.data.CANCEL_STATUS === true) {
            if (response.data.TICKET_STATUS_TYPE_NAME === "CLOSED") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + '.');   
            } else if (response.data.TICKET_STATUS_TYPE_NAME === "CANCEL") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + 'led.');   
            } 
            props.onReload();
            hideModal();
          } else {
            toast.success("Ticket is successfully cancelled");
            SendEmail(_data);
            props.onReload();
            hideModal();
          }        
        })
        .catch((err) => {
          toast.error("Failed to cancel ticket. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        })

      } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to cancel ticket. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }

    const hideModal = () => {
        setEditData({REASON: null});
        props.onHide();
    };

    const inputRequiredHandler = (event) => {
      let functionName = "";
  
      try {
        functionName = inputRequiredHandler.name;
        const name = event.target.name;
        functionName = inputRequiredHandler.name + "_" + name;
        const id = event.target.id;
        const val = event.target.value;
        if (val.length === 0 || val.trim().length === 0) {
          setInputError((prevState) => ({
            ...prevState,
            [id]: name + " could not be empty.",
          }));
        } else {
          setInputError((prevState) => ({
            ...prevState,
            [id]: "",
          }));
        }

        setEditData((prevState) => ({
          ...prevState,
          [id]: val,
        }));

      } catch (err) {
        common.c_LogWebError(props.page, functionName, err);
      }
    };

    const message = (
        <>
            Confirm to cancel?
            <br />
            {/* Ticket Num:
            {<b>{props.viewData !== null && props.viewData.TICKET_NUM}</b>} */}
            {/* <br /> */}
            <table width={"70%"} style={{margin: "1rem 3rem"}} centered="true">
                <tbody>
                    <tr>
                        <td style={{textAlign: "left"}}>Ticket Num </td>
                        <td width={"5%"}>:</td>
                        <td className={CssClass.inputValueLabel}>{props.viewData !== null && props.viewData.TICKET_NUM}</td>
                    </tr>
                    <tr>
                        <td style={{textAlign: "left"}}>Reason*</td>
                        <td width={"5%"}>:</td>
                        <td className={CssClass.inputValueLabel}>
                            <Comp.TextArea
                                id="RESPONSE_DETAILS"
                                name="Reason"
                                type="text"
                                errorMessage={inputError.RESPONSE_DETAILS}
                                className="form-control"
                                value={editData.RESPONSE_DETAILS}
                                onChange={inputRequiredHandler}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>           
        </>
    );

    return (
      <>
        <Comp.ConfirmModal
          show={props.showHide}
          onHide={hideModal}
          onConfirm={cancelBtnOnClick}
          confirmCancel
        >
          {message}
        </Comp.ConfirmModal>
      </>
    );
}

export default CancelTicket;